//tutor-frontend/src/modules/lll/lll-navigation.tsx

import { ActivityNode, LllMetadata, LllNode } from "modules/lll/lll-nodes"
import { Breadcrumb } from "react-bootstrap"
import { useEffect, useState } from "react"
import { SelectedActivity } from "pages/Session/session-newactivity-types"
import { ActivityType, LessonActivity } from "modules/lesson/activity/activity.types"
import { LllNodeBranch } from "modules/lll/lll-node-branch"
import { Button } from "reactstrap"
import { lllService } from "modules/lll/lll-service"
import { getUserSession } from "common/session/user-session"
import urlJoin from "url-join"
import { lllLookupService } from "modules/lll/lll-lookup"
import { Subject } from "common/subject"
import { apiClient } from "infra/api-client"
import { BASE_URL } from "global"
import moment from "moment"
import { ActivityCounter } from "modules/lll/lll-activity-counter"
import { accessibleService } from "modules/center-services/AccessibleService"


type AddSelectedActivity = (selectedActivity: SelectedActivity) => void;

type lllNavigationProps = {
  rootTopic?: LllNode;
  lessonPlan: LessonPlan;
  addSelectedActivity: AddSelectedActivity;
  selectedActivities: SelectedActivity[];
  previouslyAssignedActivities: LessonActivity[];
  lastAttempts: {activity_fqn: string, last_attempted: string}[]
  browseMode?: boolean;
}

type LessonPlan = {
  subjectId: number;
  isHomework: 0 | 1;
}

export async function fetchLastAttempts(options: {
  "student_key": string,
  "center_key": string,
}): Promise<lllNavigationProps['lastAttempts']> {
  return apiClient.post(BASE_URL + "lll/getLastAttempts", options)
}

const subjectMapping: Record<number, string> = {}
subjectMapping[Subject.ENGLISH] = 'english';
subjectMapping[Subject.MATH] = 'maths';


export const LllNavigation = (props: lllNavigationProps) => {

  const { rootTopic, selectedActivities } = props
  const [activeNode, setActiveNode] = useState<LllNode>()
  const [activeNodePath, setActiveNodePath] = useState<LllNode[]>([])
  const [selectedFqns, setSelectedFqns] = useState<Set<string>>(new Set());
  const [initialised, setInitialised] = useState<boolean>()
  const [accessible, setAccessible] = useState<boolean>()



  useEffect(() => {
    async function _fetchAccessibleServices() {
      return accessibleService.init().then(()=>{
        const _accessible = accessibleService.hasAccessToLll();
        setAccessible(_accessible);
      })
    }

    Promise.all([_fetchAccessibleServices()])
      .then(() => {
        setInitialised(true)
      })

  }, [])

  useEffect(() => {
    setActiveNode(rootTopic)
    if (rootTopic) {
      setActiveNodePath([rootTopic])
      setActiveNode(rootTopic)
    } else {
      setActiveNodePath([])
      setActiveNode(undefined)
    }
  }, [rootTopic, props.lessonPlan.subjectId])

  useEffect( ()=>{

    const _selectedFqns = new Set<string>();

    selectedActivities?.forEach(e => {
      if (ActivityType.LLL === e.activity_type) {
        _selectedFqns.add(e.activity_ref_id!)
      }
    })
    props.previouslyAssignedActivities?.forEach(e => {
      if (ActivityType.LLL === e.activity_type) {
        _selectedFqns.add(e.activity_ref_id!)
      }
    })
    setSelectedFqns(_selectedFqns);
  }, [selectedActivities, props.previouslyAssignedActivities])



  if (!rootTopic) {
    return <></>
  }

  const subjectId = props.lessonPlan.subjectId
  const addActivity = (node: ActivityNode) => {

    const branch = LllNodeBranch.createTo(node)
    console.info(branch.description)


    const selectedActivity: SelectedActivity = {
      activity_type: ActivityType.LLL,
      // id: 0,
      is_homework: props.lessonPlan.isHomework,
      // level_id: 0,
      // level_name: "",
      name: branch.description,
      subject_id: subjectId,
      topicID: 0,
      topic_name: "LLL",
      tutor_comments: "",
      type: "LLL",
      coin: LllMetadata.coinsPerActivity,
      activity_ref_id: node.fqn
    }

    props.addSelectedActivity(selectedActivity)
  }


  function childrenNodeSelected(node: LllNode) {

    if (node.isActivity()) {
      return
    }
    setActiveNode(() => node)
    setActiveNodePath(e => {
      e.push(node)
      return e
    })
  }

  function breadcrumbItemSelected(node: LllNode) {

    for (let idx = 0; idx < activeNodePath.length; idx++) {
      const _topic = activeNodePath[idx]
      if (activeNodePath[idx].fqn === node.fqn) {
        activeNodePath.splice(idx + 1)
        setActiveNode(_topic)
        break
      }
    }

  }

  const notAccessibleMarkup = (
    <div>
      <div className="d-flex justify-content-center mb-2 p-2 font-size-20"
           style={{
             backgroundColor: '#007bff',
             color: '#ffffff',
             fontWeight: 'bold',
             borderRadius: '4px',
             padding: '0.5rem 1rem'
           }}>
        <p className="mb-0"
           style={{ color: '#ffffff' }}>Centre Optional Add on - Your centre needs to subscribe to access the program</p>
      </div>
    </div>
  )


  const accessibleMarkup = (
    <div>
      <div>
        <Breadcrumb style={{fontSize: '1.1rem', fontWeight: '700'}}>
          {activeNodePath.map(node => {
            return (
              <Breadcrumb.Item
                onClick={() => breadcrumbItemSelected(node)}
                active={node === activeNodePath[activeNodePath.length - 1]}>
                <span style={{color: (node.sequenceBoundary) ? "blue" : ""}}>{node.displayName}</span>
              </Breadcrumb.Item>
            )
          })}
        </Breadcrumb>
      </div>

      <div>

        {activeNode?.getChildren()?.map(node => {

          const branch = LllNodeBranch.createTo(node);

          if (node.isTopic()) {
            if (props.lessonPlan.subjectId === Subject.ENGLISH && !branch.hasSubject(subjectMapping[Subject.ENGLISH])) {
              return <></>
            }
            if (props.lessonPlan.subjectId === Subject.MATH && !branch.hasSubject(subjectMapping[Subject.MATH])) {
              return <></>
            }
          }

          if(node.name === 'Downloads') {
            return <></>
          }

          const lastAttempted = (props.lastAttempts)?.find( e=> {
            return e.activity_fqn === node.fqn
          })?.last_attempted;

          const activityCounter = new ActivityCounter(node, subjectMapping[props.lessonPlan.subjectId]);

          return (
            <LllNodeCard
              node={node}
              activityCount={activityCounter.count}
              onTopicSelected={childrenNodeSelected}
              onActivitySelected={addActivity}
              disabled={selectedFqns.has(node.fqn)}
              lastAttempted={lastAttempted}
              browseMode={props.browseMode}
            ></LllNodeCard>
          )
        })}

      </div>
    </div>
  )

  return (initialised &&
    <div>
      {accessible ? accessibleMarkup : notAccessibleMarkup}
    </div>
  )

}


type LllNodeCardProps = {
  node: LllNode;
  activityCount: number;
  onTopicSelected: (node: LllNode) => void;
  onActivitySelected: (node: ActivityNode) => void;
  disabled: boolean;
  lastAttempted?: string;
  browseMode?: boolean;
}

const LllNodeCard = (props: LllNodeCardProps) => {

  const { node } = props

  async function openPreview(node: ActivityNode) {
    const baseUrl = lllLookupService.getBaseUrl();
    const token = await getAuthorisationToken();
    const activityUrl = urlJoin(baseUrl, node.relativeLink + `?token=${token}`);

    window.open(activityUrl)
  }

  async function getAuthorisationToken(){

    return lllService.createProviderToken({
      user_type: 'tutor',
      user_key: getUserSession().tutorKey,
      scope: ['login']
    })

  }

  return (
    <div
      className={
        `d-flex flex-column justify-content-center mb-2 p-2 w-85 m-auto font-size-18 rounded-3
                ${!node.isActivity() ? "cursor-pointer" : ""}
              `}
      style={{ height: "100px", border: "1px solid black", boxShadow: "5px 5px 5px 0px #ADC0CE" }}
      onClick={() => props.onTopicSelected(node)}
    >
      <div className="d-flex justify-content-between">
        <div style={{ fontSize: '1.1rem', fontWeight: '700', color: (node.sequenceBoundary) ? "blue" : "" }}>
          {node.displayName || node.name}
          {!node.isActivity() && <span style={{fontStyle: 'italic', marginLeft: '10px'}}>({props.activityCount} activities)</span>}
        </div>
        {node.isActivity() &&

          <div className="d-flex gap-2 align-items-center">

            {props.lastAttempted &&
              <span className="mr-3" style={{fontStyle: 'italic', fontSize: '80%'}}>Last Attempted: {moment(props.lastAttempted).format("DD MMM YYYY")}</span>
            }

            {!props.browseMode &&
              <Button color="danger"
                      onClick={() => props.onActivitySelected(node)}
                      disabled={props.disabled}
              >
                Select
              </Button>
            }
            <Button color="danger" outline={true} className={'bg-white text-danger'}
                    onClick={() => {openPreview(node)}}
            >
              Preview
            </Button>
          </div>
        }

      </div>
    </div>
  )

}